import React from 'react';
import styles from './TotalTonnage.module.css';

const TotalTonnage = ({ total }) => (
  <div className={styles.TotalTonnage}>
    <p className={styles.Label}>Total Pounds Lifted</p>
    <p className={styles.Value}>{Number(total).toLocaleString()}</p>
  </div>
);

export default TotalTonnage;
